// extracted by mini-css-extract-plugin
module.exports = {"panel":"DebugPanel_panel__aW0Pw"};